<template>
  <div id="account-header">
    <a v-if="$route.name !== 'account.subcompany'" :href="$brand.url.site"><img
      :src="'/static/img/' + $brand.logo"
      :alt="$brand.label"
      class="logo"
    ></a>
    <router-link v-if="$route.name === 'account.subcompany'" to="/"><img
      :src="'/static/img/' + $brand.logo"
      :alt="$brand.label"
      class="logo"
    ></router-link>
    <div class="line"/>
    <div v-if="$route.name === 'account.company' || $route.name === 'account.new'" class="steps">
      <div v-if="currentUserInfo" class="user-info">
        <div
          class="avatar"
          :style="{ backgroundImage: `url('${blobUrlAvatar ? blobUrlAvatar : currentUserInfo.avatarUrl}')` }"
        />
        Hello, <span>{{ currentUserInfo.firstname }}</span>
      </div>
      <div v-if="$route.name === 'account.new' && !currentUserInfo" class="step active">
        <div class="rond"/>
        <p>{{ currentEmail }}</p>
      </div>
      <div v-if="$route.name === 'account.new'" class="step active">
        <div class="rond" :class="{ ellipsis: $route.name === 'account.new' }">
          <span/>
          <span/>
          <span/>
        </div>
        <p>Vos informations</p>
      </div>
      <div class="step" :class="{ active: $route.name === 'account.company' }">
        <div class="rond" :class="{ ellipsis: $route.name === 'account.company' }">
          <span/>
          <span/>
          <span/>
        </div>
        <p>Votre entreprise</p>
      </div>
    </div>
    <div v-if="$route.name === 'account.subcompany'">
      <div class="steps">
        <div class="user-info">
          <div
            class="avatar"
            :style="{ backgroundImage: `url('${(accountStore.mainPicture && accountStore.mainPicture.format) ? accountStore.mainPicture.format.small : null}')` }"
          />
          Hello, <span>{{ accountStore.firstName }}</span>
        </div>
        <div class="step active">
          <div class="rond ellipsis">
            <span/>
            <span/>
            <span/>
          </div>
          <p>{{ $t('add_account.header_label') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';

export default {
  computed: {
    ...mapStores(useAccountStore, useAuthStore),
    currentEmail() {
      return this.authStore.currentEmail;
    },
    currentUserInfo() {
      return this.accountStore.create.userInfo;
    },
    blobUrlAvatar() {
      const avatar = this.currentUserInfo && this.currentUserInfo.avatarUrl;
      return avatar instanceof Blob ? URL.createObjectURL(avatar) : null;
    },
  },
};
</script>
